import { Icon, MediaImage, MenuButton, PathButton } from "shared/react";
import { getGroupPath } from "shared/schema";
import { getMediaImageStyle } from "shared/util/style";
import { useGroupContext } from "./GroupContext.js";
import { GroupMenu } from "./GroupMenu.js";

/** Short header is used on messages list page and message single page where space is at a premium. */
export function GroupShortHeader(): React.ReactElement {
	const group = useGroupContext();
	const { id: gid, name, photo, cover, hue } = group;
	const path = getGroupPath(group);

	return (
		<header className="panel pad-none" style={getMediaImageStyle(cover, hue)}>
			<div className="targeted flex-row space-none width-wide">
				<a href={path} className="photo size-3x">
					{photo ? <MediaImage path={photo} /> : <Icon icon="chat" />}
				</a>
				<h1 className="text-ellipsis flex-full text-left pad-xsmall">
					<a href={`${path}/about`} className="target">
						{name}
					</a>
				</h1>
				<PathButton mods="flex-stretch button-quiet" path={`${path}/assigned`}>
					<Icon icon="challenge" />
				</PathButton>
				<PathButton mods="flex-stretch button-quiet" path={`${path}/leaderboards`}>
					<Icon icon="leaderboard" />
				</PathButton>
				<MenuButton mods="flex-stretch button-quiet" menu={<GroupMenu gid={gid} />} />
			</div>
		</header>
	);
}
